import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import StatusViewEditComponent from "../../company/components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import {
  masterExternalIdentificationProviderListApiCall,
  masterExternalIdentificationProviderCreateApiCall,
  masterExternalIdentificationProviderUpdateApiCall,
  masterExternalIdentificationProviderDeleteApiCall,
} from "../../../../helpers/fakebackend_helper";

/**
 * Super Admin CRUD for the master external-identification provider catalogue
 * (ZCRM_Master). Per-company ExternalIdentificationProvider rows link to these
 * via MasterExternalIdentificationProvider_Id - the stable key across every
 * company database. Self-contained (direct API calls), same look as the Master
 * Payment Provider panel.
 */
const MasterExternalIdentificationProvider = () => {
  const [statusList, setStatusList] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateItemStatus, setUpdateItemStatus] = useState({});
  const [createStatus, setCreateStatus] = useState({
    Name: "New Provider",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const loadList = async () => {
    try {
      const response = await masterExternalIdentificationProviderListApiCall();
      const list = response?.masterexternalidentificationprovider_list || [];
      setStatusList([...list].sort((a, b) => b.Id - a.Id));
    } catch (e) {
      toast.error("Could not load master providers");
    }
  };

  useEffect(() => {
    loadList();
  }, []);

  const handleCreateNewStatus = async () => {
    const response = await masterExternalIdentificationProviderCreateApiCall([
      createStatus,
    ]);
    if (response?.status === 200) {
      toast.success(response.message);
      loadList();
    } else {
      toast.error(response?.message || "Could not create");
    }
  };

  const handleDeleteStatus = async () => {
    const response = await masterExternalIdentificationProviderDeleteApiCall([
      deleteStatus,
    ]);
    if (response?.status === 200) {
      toast.success(response.message);
      setDeleteModal(false);
      loadList();
    } else {
      toast.error(response?.message || "Could not delete");
    }
  };

  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    const payload = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delay = setTimeout(async () => {
      const response = await masterExternalIdentificationProviderUpdateApiCall([
        payload,
      ]);
      if (response?.status === 200) {
        loadList();
      } else {
        toast.error(response?.message || "Could not update");
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [updateItemStatus]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => setDeleteModal(false)}
        />
      )}

      <SettingsPanel
        title="Master External Id Providers"
        description="External identification providers available to every company (Microsoft, Xero, BrightPay…). Per-company providers link to these via the master list."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
        />
      </SettingsPanel>
    </>
  );
};

export default MasterExternalIdentificationProvider;
